// extracted by css-extract-rspack-plugin
export default {"tabs":"LinkTab__tabs--nTdmO","withContract":"LinkTab__withContract--cpIoT"};